// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"076ceddb","734":"0f8b7cba"}[chunkId] + ".chunk.js";
};